import { render, staticRenderFns } from "./SessionManager.vue?vue&type=template&id=2fddd6c4&scoped=true"
import script from "./SessionManager.vue?vue&type=script&lang=js"
export * from "./SessionManager.vue?vue&type=script&lang=js"
import style0 from "./SessionManager.vue?vue&type=style&index=0&id=2fddd6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fddd6c4",
  null
  
)

export default component.exports